<template>
  <div id="app">
    <div id="Notifications"></div>
    <internet-message
      v-if="!internetStatus.connection || internetStatus.speed < 0.5"
      :internetStatus="internetStatus"
    ></internet-message>

    <router-view />
    <ActionModal />
  </div>
</template>

<script>
import ActionModal from "@/components/Base/ActionModal";
import InternetMessage from "./components/Base/InternetMessage.vue";
export default {
  components: { ActionModal, InternetMessage },
  data() {
    return {
      internetStatus: {
        connection: true,
        speed: 10, //window.navigator.connection.downlink,
      },
    };
  },
  methods: {
    GET_LANG() {
      const lang = localStorage.getItem("lang");
      if (this.$i18n.availableLocales.includes(lang)) this.$i18n.locale = lang;
    },
    CONNECTION_INFORMATION_OF_INTERNET() {
      const vm = this;
      this.internetStatus.connection = window.navigator.onLine;
      window.addEventListener("offline", () => {
        vm.internetStatus.connection = false;
      });
      window.addEventListener("online", () => {
        vm.internetStatus.connection = true;
      });
    },
  },
  async created() {
    // dil bilgisi alınır.
    this.GET_LANG();
    //  this.CONNECTION_INFORMATION_OF_INTERNET();
  },
};
</script>

<style></style>
